import {computed,onScopeDispose,ref} from 'vue'
import {useQueryClient} from '@tanstack/vue-query'
import {useAuthStore} from '@/stores/auth'
import {useRoute} from 'vue-router'

export function useCurrentEventMetadata() {
const route=useRoute()
// Observe the shared V2 query cache; page refetches/realtime invalidation refresh
// the title without another API request or a separate stale copy of event data.
const queryClient = useQueryClient(), auth = useAuthStore(), cacheRevision = ref(0)
const unsubscribe = queryClient.getQueryCache().subscribe(event => {
  if (['tryoutCapture', 'tryoutCaptureWorkspace', 'athleteJournal', 'tryoutContext', 'tryoutHome', 'sessionPlan', 'participantImportMetadata', 'tryoutParticipants', 'tryoutSetup'].includes(String(event.query.queryKey[0]))) cacheRevision.value++
})
onScopeDispose(unsubscribe)
const currentEvents = computed(() => {
  void cacheRevision.value
  const club = String(route.params.clubId || ''), season = String(route.params.seasonId || ''), eventId = String(route.params.tryoutId || '')
  if (!club || !season || !eventId) return []
  const keys = [
    ['tryoutCapture', club, season, eventId],
    ['tryoutCaptureWorkspace', club, season, eventId, String(auth.user?.details?.id || auth.user?.id || '')],
    ['participantImportMetadata', season, eventId, club],
    ['tryoutParticipants', club, season, eventId],
    ['tryoutSetup', season, eventId, club],
    ['athleteJournal', club, season, eventId, auth.user?.id || ''],
    ['tryoutContext', club, season, eventId],
    ['tryoutHome', season, eventId, club, auth.user?.details?.id || auth.user?.id || ''],
  ]
  return keys.map(queryKey => queryClient.getQueryCache().find({queryKey, exact:true}))
    .filter(query => query?.state.status === 'success')
    .sort((a,b) => (b?.state.dataUpdatedAt || 0) - (a?.state.dataUpdatedAt || 0))
    .map(query => (query?.state.data as {event?: {id?: string; title?: string; participantNoun?: string; sessionNoun?: string}} | undefined)?.event)
    .filter(event => event?.id === eventId)
})
const eventTitle = computed(() => currentEvents.value.find(event => event?.title)?.title || '')
return {currentEvents,eventTitle,cacheRevision}
}
